import gql from "graphql-tag";

export default {
    getPer: gql`query userPreference {
        userPreference {
          openid
          text
          preferences {
            name
            text
            type
            valueString
          }
        }
      }`,

    addPer: gql`mutation addUserPreferenceItem($name: String!, $value: String!) {
        addUserPreferenceItem(name: $name, value: $value) {
          name
          text
          type
          valueString
          valueInt
          valueFloat
          valueBoolean
          multiTenancy
          creator
          created
        }
      }`,


    editPer: gql`mutation editUserPreference($name: String!, $value: String!) {
  editUserPreference(name: $name, value: $value) {
    name
    text
    type
    valueString
  }
}`
}


// WEBPACK FOOTER //
// ./src/graphql/avatar.js